/* eslint camelcase: 0 */

// El bloque emite los tres canales sueltos ("R, G, B") porque quien lo consume
// los interpola dentro de su propia llamada.
export const colour_educabot = (block, generator) => {
  const colour = block.getFieldValue('COLOUR');
  const red = parseInt(colour.substring(1, 3), 16);
  const green = parseInt(colour.substring(3, 5), 16);
  const blue = parseInt(colour.substring(5), 16);

  return [`${red}, ${green}, ${blue}`, generator.ORDER_ATOMIC];
};

export const colour_bhoot = (block, generator) => {
  const colour = block.getFieldValue('COLOR');
  const red = parseInt(colour.substring(1, 3), 16);
  const green = parseInt(colour.substring(3, 5), 16);
  const blue = parseInt(colour.substring(5), 16);

  return [`${red}, ${green}, ${blue}`, generator.ORDER_ATOMIC];
};
